require('./brokerWarrantsAdvancedSellSuccess.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const AdvancedBuySellWarrantsSummary = require('components/broker/commons/advancedBuySellWarrantSummary/advancedBuySellWarrantSummary');

// @ helpers
const { formatText } = require('core/i18n').i18n;

const BrokerWarrantsAdvancedSellSuccess = props => {
    const { immProductFile, immBrokerWarrantsAdvancedSell, immStocksContract } = props;
    const successMessage = formatText('broker-warrantsAdvancedSellSuccessStepMessage');
    const mainButtonLabel = formatText('broker-stocksAdvancedBuySuccessStepBackToWalletButtonLabel');
    const secondaryButtonLabel = formatText('broker-warrantsAdvancedBuySuccessWizardSecondaryButtonLabel');
    return (
        <WizardSuccess
            successMessage={successMessage}
            customClassName="warrants-advanced-buy-success"
            mainButton={{label: mainButtonLabel, url:'/myprofile/broker', modifier: 'secondary'}} //@hardcoded TODO fix urls
            secondaryButton={{label: secondaryButtonLabel, url:'/myprofile/broker'}}
        >
            <div>
                <h3 className="warrants-advanced-buy-success__summary-header">
                    {formatText('broker-stocksAdvancedSellSuccessStepSubtitle')}
                </h3>
                <AdvancedBuySellWarrantsSummary
                    immProductFile={immProductFile}
                    immBrokerWarrantsAdvancedState={immBrokerWarrantsAdvancedSell}
                    immStocksContract={immStocksContract}
                    isSell={true}
                />
            </div>
        </WizardSuccess>
    );
};

BrokerWarrantsAdvancedSellSuccess.propTypes = {
    immProductFile: PropTypes.object.isRequired,
    immBrokerWarrantsAdvancedSell: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired
};

module.exports = BrokerWarrantsAdvancedSellSuccess;